import * as React from "react"
import List from "@mui/material/List"
import ListItem from "@mui/material/ListItem"
import ListItemAvatar from "@mui/material/ListItemAvatar"
import ListItemText from "@mui/material/ListItemText"
import Avatar from "@mui/material/Avatar"
import IconButton from "@mui/material/IconButton"
import FolderIcon from "@mui/icons-material/Folder"
import DeleteIcon from "@mui/icons-material/Delete"

import PropertySection from "./PropertySection"


// ---------------------------------------------------------------------------
// PropertyDocumentsCard — "Documents" section of the Location tab.
//
// DECISION: still a static placeholder — storage isn't wired up yet (this
// was previously inline JSX in Property.js with the same dummy data).
// Pulled into its own component so its eventual real implementation
// (fetch, upload, delete) has a natural home, matching every other section
// on the page.
//
// DECISION: lives in "Location", not "Bien". The documents shown here —
// the lease itself, the tenant's insurance certificate, the tenant's
// notice — are lease paperwork, not building paperwork. They stop being
// relevant the day the tenant leaves, same as the rest of this tab.
// ---------------------------------------------------------------------------
const PLACEHOLDER_FILES = [
    { name: "Contrat de location",     date: "2024-08-11 17:30" },
    { name: "Attestation d'assurance", date: "2024-08-11 17:30" },
    { name: "Préavis locataire",       date: "2024-08-11 17:30" },
]

export default function PropertyDocumentsCard() {
    return (
        <PropertySection title="Documents">
            <List dense disablePadding>
                {PLACEHOLDER_FILES.map(({ name, date }) => (
                    <ListItem
                        key={name}
                        disableGutters
                        secondaryAction={
                            <IconButton edge="end" aria-label="supprimer" size="small">
                                <DeleteIcon fontSize="small" />
                            </IconButton>
                        }
                    >
                        <ListItemAvatar>
                            <Avatar variant="rounded" sx={{ width: 32, height: 32, bgcolor: "action.selected" }}>
                                <FolderIcon sx={{ width: 18, height: 18, color: "text.secondary" }} />
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                            primary={name}
                            secondary={date}
                            primaryTypographyProps={{ variant: "body2" }}
                            secondaryTypographyProps={{ variant: "caption" }}
                        />
                    </ListItem>
                ))}
            </List>
        </PropertySection>
    )
}
